import React from "react";

const ExStackTools = () => {
    return(
        <div className="ex-stacks-tools">
            <div className="ex-stacks-tools">
                <h3>Experience Web Stack And Tools</h3>
                <div className="borders">
                    <div className="border">React</div>
                    <div className="border">Node js.</div>
                    <div className="border">NPM</div>
                    <div className="border">Bootstrap</div>
                    <div className="border">Firebase</div>
                    <div className="border">Github</div>
                    <div className="border">Netlify</div>
                </div>
            </div>
        </div>
    )
}

export default ExStackTools;

